import Repository from '@/repositories/Repository'
import WeatherWarningHistory2 from '@/models/WeatherWarningHistory2'
import { encodeGetParams } from '@/lib/utils'
import { WeatherWarningHistoryParams } from '@/repositories/weather-warning-history-repository'

// R08気象警報注意報履歴API（app2 / weather-warning-history2）
class WeatherWarningHistory2Repository extends Repository {
  constructor() {
    super('/weather-warning-history2')
  }

  async get(params: WeatherWarningHistoryParams) {
    const query = encodeGetParams<WeatherWarningHistoryParams>(params)
    const attributes = await super._get(query)

    return new WeatherWarningHistory2(attributes)
  }
}

export default WeatherWarningHistory2Repository
